var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"fill-height"},[_c('v-col',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.key})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }